import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvService } from '../../environments/env.service';
import { RespuestaOperacionServicio, FiltroExt } from '../models/';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ConsultaService {
  urlAPI: string;

  constructor(private http: HttpClient,
              private env: EnvService,
              public datepipe: DatePipe) {
    this.urlAPI = env.APP_BACKEND_PATH;
  }

  consultarEstado(filtro: FiltroExt): Observable<RespuestaOperacionServicio> {
    return this.http
      .post<RespuestaOperacionServicio>(`${this.urlAPI}consulta/GetConsulta`, filtro);
  }

}
